'use client';

import { useEffect, useState } from 'react';
import { Loader2 } from 'lucide-react';
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';

type Props = {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onSubscribe: () => Promise<void> | void;
};

export function SubscriptionRequiredDialog({ open, onOpenChange, onSubscribe }: Props) {
  const [isRedirecting, setIsRedirecting] = useState(false);

  useEffect(() => {
    if (!open) setIsRedirecting(false);
  }, [open]);

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle>Abonnement requis</DialogTitle>
          <DialogDescription>
            Votre abonnement est expiré. Réabonnez-vous pour débloquer les actions d&apos;ajout.
          </DialogDescription>
        </DialogHeader>
        <DialogFooter className="gap-2 sm:justify-end">
          <Button variant="outline" onClick={() => onOpenChange(false)} disabled={isRedirecting}>
            Plus tard
          </Button>
          <Button
            variant="gold"
            disabled={isRedirecting}
            onClick={async () => {
              setIsRedirecting(true);
              try {
                await onSubscribe();
              } catch {
                setIsRedirecting(false);
              }
            }}
          >
            {isRedirecting ? (
              <>
                <Loader2 className="mr-2 h-4 w-4 animate-spin" />
                Redirection...
              </>
            ) : (
              'Aller sur Stripe'
            )}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
